import { createContext, use } from 'react';

import { Compound, GProduct, Variant } from '@/types';

interface ISelectOption<T> {
  label: string;
  value: T;
}

export interface UnitPricingTier {
  qty: number;
  price: number;
}

export interface CompoundType {
  type: Compound;
  value: string | null;
}

export interface IProductWithUrls extends GProduct {
  brand_url?: string;
  category_url?: string;
}

interface ProductState {
  product: IProductWithUrls;
  isSpecial: boolean;
  quantity: number;
  weightVariant: Variant;
  variants: Variant[];
  unitPricingTiers?: UnitPricingTier[];
  unitPricingTier?: UnitPricingTier;
  updateWeightVariant: (_option: ISelectOption<string>) => void;
  updateUnitPricingTier: (_option: UnitPricingTier) => void;
  compoundList: CompoundType[];
  selectedProductId?: string;
  setSelectedProductId: (_id: string) => void;
}

const ProductContext = createContext<undefined | ProductState>(undefined);
ProductContext.displayName = 'ProductContext';

const useProductContext = () => {
  const context = use(ProductContext);

  if (!context) {
    throw new Error('useProductContext must be used within a ProductProvider');
  }

  return context;
};

export { ProductContext, useProductContext };
